function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Loading = function Loading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M20.158 18.552a1 1 0 0 1 .019 1.414 11.09 11.09 0 0 1-8.004 3.379 1 1 0 1 1 0-2 9.1 9.1 0 0 0 6.57-2.773 1 1 0 0 1 1.415-.02m-15.19-.7a9.25 9.25 0 0 0 3.549 2.736 1 1 0 0 1-.797 1.834 11.25 11.25 0 0 1-4.321-3.33 1.001 1.001 0 0 1 1.57-1.24M12.174 1c6.16 0 11.171 5.012 11.171 11.173 0 1.056-.147 2.1-.438 3.106a1 1 0 1 1-1.921-.554 9.2 9.2 0 0 0 .359-2.552C21.344 7.115 17.23 3 12.173 3a1 1 0 1 1 0-2M2.21 9.876a1 1 0 0 1 .865 1.119 9.2 9.2 0 0 0 .199 3.411 1 1 0 0 1-1.941.484 11.3 11.3 0 0 1-.242-4.15 1.005 1.005 0 0 1 1.118-.864M5.432 4.49a1 1 0 0 1 .045 1.413 9.2 9.2 0 0 0-1.271 1.72A1 1 0 1 1 2.47 6.63c.43-.755.952-1.459 1.547-2.093a1 1 0 0 1 1.414-.046M8.776 2.44a1 1 0 0 1-.372 1.364q-.033.019-.069.036a.999.999 0 1 1-.865-1.803 1 1 0 0 1 1.306.403"
  }));
};
export default Loading;